import { useServiceHistoryVauxhallQuery, useServiceHistoryVauxhallLookupMutation } from '../../../api';
import styles from './styles.module.scss';
import { useAuth } from 'features/auth/contexts/auth';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ButtonWithIcon } from 'shared';
import { formatDate } from 'utils/formats';

type Props = {
  serviceHistoryId?: number | null;
};

export const VauxhallVehicleHistorySection: FC<Props> = ({ serviceHistoryId }) => {
  const { currentUser } = useAuth();
  const { mutate, isLoading } = useServiceHistoryVauxhallLookupMutation();

  const { data, isFetching, refetch } = useServiceHistoryVauxhallQuery(
    { serviceHistoryId: serviceHistoryId ?? 0 },
    { enabled: !!serviceHistoryId }
  );

  const renderSkeletonRows = () =>
    Array.from({ length: 5 }, (_, index) => (
      <tr key={`skeleton-${index}`}>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
        <td>
          <Skeleton height={20} />
        </td>
      </tr>
    ));

  const handleLookUpClick = () => {
    mutate(
      { serviceHistoryId: serviceHistoryId ?? 0, userId: currentUser?.userId ?? 0 },
      {
        onSuccess: () => {
          refetch();
        }
      }
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>Vauxhall Service History</div>

      <div className={styles.emptyContainer}>
        {!data && <div className={styles.emptyTitle}>Service History not found</div>}
        <div>
          <ButtonWithIcon iconPath="/media/icons/custom/zoom_1.svg" onClick={handleLookUpClick} isLoading={isLoading}>
            Look Up Vauxhall Service History
          </ButtonWithIcon>
        </div>
      </div>

      {data && (
        <div>
          <div className={styles.createdInfo}>
            <div>
              Last Look Up - {data.createdInfo?.creationDate ? formatDate(data.createdInfo?.creationDate) : '-'} by{' '}
              {data.createdInfo?.name ?? '-'}
            </div>
            <ButtonWithIcon
              iconPath="/media/icons/custom/zoom_1.svg"
              btnStyle="light-primary"
              onClick={() => refetch()}
              isLoading={isFetching}
            >
              Update
            </ButtonWithIcon>
          </div>

          <div className={styles.scrollContainer}>
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Invoice Code</th>
                    <th>Date</th>
                    <th>Retailer</th>
                    <th>Mileage</th>
                    <th>Type</th>
                    <th>Channel</th>
                    <th>Labours</th>
                  </tr>
                </thead>
                <tbody>
                  {isFetching
                    ? renderSkeletonRows()
                    : data.values?.map((x, xi) => (
                        <tr key={xi}>
                          <td data-label="Invoice Code">{x.invoiceCode ?? '-'}</td>
                          <td data-label="Date">{x.date ? formatDate(x.date) : '-'}</td>
                          <td data-label="Retailer">{x.retailer ?? '-'}</td>
                          <td data-label="Mileage">{x.mileage ?? ''}</td>
                          <td data-label="Type">{x.type ?? '-'}</td>
                          <td data-label="Channel">{x.channel ?? '-'}</td>
                          <td data-label="Labours">
                            {x.labours && x.labours.length > 0 && (
                              <div className="table-responsive">
                                <table className="table">
                                  <thead>
                                    <tr>
                                      <th>Labour Id</th>
                                      <th>Description</th>
                                      <th>Type</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {x.labours?.map((l, li) => (
                                      <tr key={li}>
                                        <td>{l.code}</td>
                                        <td>{l.description}</td>
                                        <td>{l.type}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
